import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("input", {
  name: "current_bank_account_name",
  type: "text",
  class: "w-full rounded-md"
}, null, -1)
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  name: "current_bank_name",
  type: "text",
  class: "w-full rounded-md"
}, null, -1)
const _hoisted_6 = { class: "py-2" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "py-2" }
const _hoisted_9 = { class: "py-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("textarea", {
  class: "w-full h-20 rounded-md",
  name: "remark"
}, null, -1)

import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import ToolsUpload from '../../tools/Upload.vue'
import ToolsInputMobile from '../../tools/InputMobile.vue'
import ExampleTicketToolTip from './tooltip/ExampleTicketTooltip.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeBankAccountName',
  props: {
  username: String
},
  setup(__props) {

const props = __props

const store = useStore();

const username = ref(props.username);

const validateInput = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  // กรองเฉพาะตัวเลข 0-9
  username.value = value.replace(/[^0-9]/g, '').slice(0, 10);
};

watch(() => props.username, (newVal) => {
  username.value = newVal; // อัพเดตค่า username ถ้ามีการเปลี่ยนแปลงจาก props
});

const getExampleImage = () =>{
  const baseUrl = window.location.origin
  return `${baseUrl}/ticket-example/รูปตัวอย่าง ขอแก้ไขชื่อบัญชีลูกค้า.png`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.currentBankAccountName')) + " ", 1),
        _createVNode(ExampleTicketToolTip, {
          image: getExampleImage()
        }, null, 8, ["image"])
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.newBankAccountName')) + " ", 1),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.operatorName')) + " ", 1),
      _createElementVNode("input", {
        value: _unref(store).state.selectedOperator.name,
        name: "operator_name",
        type: "text",
        class: "w-full rounded-md",
        disabled: true
      }, null, 8, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.customerUsername')) + " ", 1),
      _createVNode(ToolsInputMobile, { name: "username" })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.remark')) + " ", 1),
      _hoisted_10
    ]),
    _createVNode(ToolsUpload)
  ], 64))
}
}

})